import { render } from "./BrazilMapContainer.vue?vue&type=template&id=742c2e96"
import script from "./BrazilMapContainer.vue?vue&type=script&lang=js"
export * from "./BrazilMapContainer.vue?vue&type=script&lang=js"

import exportComponent from "Z:\\Backups\\Backup Site tecmar\\07.10.2026\\tecmar-transportes-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__